import React, { Suspense, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import classNames from "classnames";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import MosaicManager from "src/pages/MosaicManager/MosaicManager";
import { useSelector, useDispatch } from "react-redux";
import { store } from "src/redux/store/Store";
import {
  getCustomerStructures,
  getCustomerCustomAirports,
  getAircraftStatuses,
} from "src/redux/actions/Structure.Actions";
import { getCustomerCustomPages } from "src/redux/actions/Custom/Custom.Actions";
import { ISavedFlightDisplayOptions } from "src/redux/reducers/FlightTimelineReducer";
import { setAircraftFilters, setAircraftSort } from "src/redux/actions/flights/FlightTimeline.Actions";
import { API, Auth } from "aws-amplify";
import { Theme } from "@mui/material";
import { bootstrapCustomerFeatures } from "src/features/bootstrapCustomerFeatures";

const AppRoutes = (): JSX.Element => {
  const [readyToRender, setReadyToRender] = useState(false);
  const dispatch = useDispatch();
  const customerStructure = useSelector((state: IRootState) => state.structures.customerStructure);
  const windowManager = useSelector((state: IRootState) => state.windowManager);

  useEffect(() => {
    const setFilters = async (): Promise<void> => {
      await bootstrapCustomerFeatures();
      const userSession = await Auth.currentSession();
      const token = userSession.getIdToken().getJwtToken();
      await API.post("skytrains", "/ssoassociate", {
        headers: { Accept: "*/*", Authorization: token },
      });
      await dispatch(getCustomerStructures());
      try {
        if (customerStructure) {
          const state = store.getState();
          const savedFiltersObj = state?.authentication?.appSettings?.timelineAircraftFilters;
          const savedFilters =
            savedFiltersObj?.aircraftFilter !== undefined || savedFiltersObj?.aircraftSort !== undefined
              ? (savedFiltersObj as ISavedFlightDisplayOptions)
              : null;
          if (savedFilters) {
            // If saved filters are found in localstorage, apply them to redux store.
            dispatch(setAircraftFilters(savedFilters.aircraftFilter));
            dispatch(setAircraftSort(savedFilters.aircraftSort));
          } else throw new Error("Bad filter/sort saved setting.");
          // Retrieve Aircraft Statuses and update redux map. The thunk reads the aircraft list
          // off live state and no-ops when there are none, so there is nothing to guard here.
          dispatch(getAircraftStatuses());
        }
      } catch (err) {
        // TODO: Handle/log error properly.
      }

      // Make a call to load in common airports and store them in the structures object.
      // This object will also have any "searched" airports during session mapped to it as well.
      await dispatch(getCustomerCustomAirports());
      // Retrieve any Custom Schemas defined for customers (flight and movementMessages currently).
      await dispatch(getCustomerCustomPages());

      // Once all required calls are completed, set readyToRender true.
      setReadyToRender(true);
    };
    const ignore = false;
    if (!ignore) {
      setFilters();
    }
    return (): void => {
      return;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const AppRoutesStyles = (theme: Theme): any => ({
    GridContainer: {
      flexGrow: 1,
      position: "relative",
      width: "100%",
      display:
        //@ts-ignore
        (windowManager.currentNode.hasOwnProperty("tabNodes") && windowManager.currentNode.tabNodes.length > 0) ||
        windowManager.currentNode.hasOwnProperty("direction")
          ? "flex"
          : "none",
    },
  });
  return (
    <Grid
      container
      spacing={0}
      className="approutes"
      direction="column"
      sx={(theme) => AppRoutesStyles(theme).GridContainer}
    >
      {readyToRender && (
        <Suspense fallback={<div />}>
          <MosaicManager />
        </Suspense>
      )}
    </Grid>
  );
};

export default AppRoutes;
